import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { errorPolicies as defaultOptions } from "@equiem/web-ng-lib";
import { applicationId } from "@equiem/web-ng-lib/config/applicationId";

export const globalGateway = new ApolloClient({
  cache: new InMemoryCache({}),
  link: new HttpLink({
    uri: process.env.gatewayUrl,
    fetch,
    headers: { "X-Equiem-Application": applicationId },
  }),
  defaultOptions,
  clientAwareness: {
    name: "web-ng",
  },
});
